import type { FC } from 'react';
import { Coin } from '@/shared/Coin';
import { ToggleGroup, type ToggleGroupProps } from '@/shared/ToggleGroup';
import { type Settings, useSettings } from './api';

export const DisplayQuoteToggleGroup: FC<
  Omit<
    ToggleGroupProps<Settings['displayQuote']>,
    'value' | 'options' | 'onChange'
  >
> = ({ ...props }) => {
  const [settings, setSettings] = useSettings();
  return (
    <ToggleGroup
      options={
        [
          {
            key: 'usdt',
            value: 'usdt',
            label: <Coin coin="USDT" size={6} variant="symbol" />,
          },
          {
            key: 'iqd',
            value: 'iqd',
            label: <Coin coin="IQD" size={6} variant="symbol" />,
          },
        ] as const
      }
      value={settings.displayQuote}
      onChange={(displayQuote) =>
        setSettings({
          displayQuote,
        })
      }
      {...props}
    />
  );
};
